import { Box, Loader, ModalDialog, Spacer, Text, TextNew } from '@jfs/ui-new'
import { FC, ReactComponentElement } from 'react'
import { testProps } from '../../util/util'
import { styles } from './styles'

interface AlertProps {
  type?: modalType
  title?: string
  subTitle?: string
  negativeLabel?: string
  positiveLabel?: string
  onCancelPress: () => void
  onOkPress: () => void
  visible?: boolean
  isErrorTypeButton?: boolean
  loading?: boolean
  renderCustomComponent?: ReactComponentElement
  isCancelLoading?: boolean
}

export interface modalType {
  Default: string
  Custom: string
  cancelLink: string
}

const modalTypes = {
  Default: 'Default',
  Custom: 'Custom',
  cancelLink: 'CancelLink',
}

const AlertDialog: FC<AlertProps> = ({
  title,
  subTitle,
  negativeLabel = 'No',
  positiveLabel = 'Yes, Logout',
  onCancelPress,
  onOkPress,
  visible = false,
  isErrorTypeButton = false,
  loading = false,
  type = modalTypes.Default,
  renderCustomComponent = undefined,
  isCancelLoading = false,
}: AlertProps) => {
  const isCancelType = type === modalTypes?.cancelLink
  const isSubtitlePresent = subTitle !== '' && subTitle !== undefined
  return (
    <ModalDialog type="CenteredWrap" title={''} show={visible} onDismiss={isCancelType ? onOkPress : onCancelPress}>
      <Box {...styles.alertOutercontainer} testID={'confirmDeleteId'}>
        <Box {...styles.approvetopBox}>
          <Box {...styles.approveTitlesBox}>
            {title && <Text {...styles.title(isCancelType)}>{title}</Text>}
            {subTitle && <Spacer size={15} />}
            <Text {...styles.subTitle(isCancelType)}>{subTitle}</Text>
          </Box>
        </Box>
        {renderCustomComponent && renderCustomComponent()}
        <Box bg="LIGHTEST_GREY" height={1} mt={isSubtitlePresent ? 16 : 5} />
        <Box {...styles.buttonsBox(isSubtitlePresent, isCancelType)}>
          <Box
            {...styles.approveBtn(isErrorTypeButton, isCancelType)}
            {...testProps('ok-button')}
            onPress={() => onOkPress()}>
            {!loading && (
              <TextNew numberOfLines={1} color={isErrorTypeButton ? 'ERROR' : 'PRIMARY'} type="body12">
                {positiveLabel}
              </TextNew>
            )}
            {loading && <Loader />}
          </Box>
          <Box {...styles.cancelBtn} {...testProps('cancel-button')} onPress={() => onCancelPress()}>
            {isCancelLoading ? (
              <Loader color="WHITE" />
            ) : (
              <TextNew numberOfLines={1} color="WHITE" type="body12">
                {negativeLabel}
              </TextNew>
            )}
          </Box>
        </Box>
      </Box>
    </ModalDialog>
  )
}

export { AlertDialog }
